import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import heroProductBottles from "@/assets/hero-product-bottles.png";

// WebP with JPEG fallback for broader support
const heroTreeWebP = "/hero-christmas-tree-wide.webp";
const heroTreeJPG = "/hero-christmas-tree-wide.jpg";

export const LuxuryHero = () => {
  const navigate = useNavigate();

  return (
    <section className="relative min-h-[90vh] flex items-center overflow-hidden">
      {/* Background Image - Simplified for better LCP */}
      <picture>
        <source srcSet={heroTreeWebP} type="image/webp" />
        <img 
          src={heroTreeJPG}
          alt="Beautiful decorated Christmas tree in elegant living room with fireplace"
          className="absolute inset-0 w-full h-full object-cover object-[70%_center]"
          fetchPriority="high"
          width={1616}
          height={1024}
          decoding="sync"
        />
      </picture>
      
      {/* Desktop/Tablet Angled Gradient Overlay - solid top-left to clear bottom-right */}
      <div 
        className="hidden md:block absolute inset-0 z-[1]" 
        style={{
          background: 'linear-gradient(120deg, hsl(var(--background)) 0%, hsl(var(--background)) 20%, hsl(var(--background) / 0.7) 40%, hsl(var(--background) / 0.3) 60%, transparent 80%)'
        }}
      />
      
      {/* Mobile Gradient Overlay - Angled like desktop */}
      <div 
        className="md:hidden absolute inset-0 z-[1]" 
        style={{
          background: 'linear-gradient(160deg, hsl(var(--background)) 0%, hsl(var(--background) / 0.95) 25%, hsl(var(--background) / 0.7) 50%, hsl(var(--background) / 0.4) 75%, transparent 100%)'
        }}
      />
      
      {/* Content Container */}
      <div className="container mx-auto px-4 py-12 md:py-20 relative z-10">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-8 md:gap-12">
          
          {/* Mobile: Product Image First */}
          <div className="md:hidden flex justify-center z-20 animate-fade-in">
            <img 
              src={heroProductBottles}
              alt="Christmas Tree Food bottles"
              className="w-[55%] max-w-[280px] h-auto drop-shadow-2xl animate-float"
            />
          </div>
          
          {/* Text Content */}
          <div className="max-w-xl md:max-w-lg lg:max-w-xl space-y-6 animate-fade-in">
            <h1 className="font-cormorant text-4xl md:text-5xl lg:text-7xl font-bold text-foreground leading-[1.05] tracking-tight">
              The Best Shot At A Fresher, Greener, Longer-Lasting Christmas Tree.
            </h1>
            
            <p className="text-lg md:text-xl text-foreground font-inter font-light leading-relaxed">
              Helps keep your tree fresh, green, and filling your home with that Christmas morning scent—from setup through the new year.
            </p>
            
            <Button 
              onClick={() => navigate('/products')}
              size="lg"
              className="bg-primary text-primary-foreground hover:bg-primary/90 font-inter font-semibold text-lg h-14 px-10"
            >
              Keep My Tree Fresh
            </Button>
          </div>
          
          {/* Desktop: Product Image Right */}
          <div className="hidden md:flex justify-center items-center z-20 animate-fade-in" style={{ animationDelay: '0.2s' }}>
            <img 
              src={heroProductBottles}
              alt="Christmas Tree Food bottles"
              className="w-full max-w-[400px] lg:max-w-[480px] xl:max-w-[520px] h-auto drop-shadow-2xl animate-float"
            />
          </div>
        </div>
      </div>
    </section>
  );
};
